export default function SendButtonSVG(){
    return(
        <svg height="80%" viewBox="0 0 360 342" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0 20.7592C0 6.55143 14.3993 -3.12582 27.5545 2.2408L351.389 134.348C356.596 136.473 360 141.537 360 147.161V147.161C360 154.804 353.804 161 346.161 161H20C8.95431 161 0 152.046 0 141V20.7592Z" fill="#C4C4C4"/>
<path d="M0 321.241C0 335.449 14.3993 345.126 27.5545 339.759L351.389 207.652C356.596 205.527 360 200.463 360 194.839V194.839C360 187.196 353.804 181 346.161 181H20C8.95431 181 0 189.954 0 201V321.241Z" fill="#C4C4C4"/>
</svg>
    )}